import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <div className="mobile-app-container">
      <Routes />
    </div>
  );
}

export default App;
